module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p7"
    }
  }), _vm._v(" Rich's Dine and Dash Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("This quick and easy recipe is from Rich Machesney, who works with Wyatt Fuller creating special bikes and parts for Harley-Davidson. Rich calls Hickory, North Carolina, home and had this to say about his recipe: \"For lack of a better name, I call them Dine and Dash Potatoes. Not to recall those days of getting a free meal once in a while, that's another story. I don't think I'd want to put it in writing.\"")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("6")]), _c('br'), _c('b', [_vm._v("to")]), _c('br'), _c('b', [_vm._v("8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("medium-size potatoes, diced")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("small onion, diced")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("¼")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup (½ stick) butter, melted")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("tablespoons vegetable oil")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("tablespoon Mrs. Dash seasoning")])])])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Preheat the oven to 400°F.")]), _vm._v(" "), _c('li', [_vm._v("Place the potatoes and onion in a baking dish and drizzle with the butter and oil. Sprinkle with the Mrs. Dash and bake for 45 minutes, stirring occasionally. They also come out great cooked on a grill in a foil bag.")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MAKES")]), _vm._v(" 4 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("TO")]), _vm._v(" 6 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("SERVINGS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 93
// module chunks = 0